const LAUNCH_SEARCH = 'LaunchSearch';
const START_SEARCH = 'StartSearch';
const SEARCH_RESULTS_RENDERED = 'SearchResultsRendered';
const SEARCH_NO_RESULTS_RENDERED = 'SearchNoResultsRendered';
const SEARCH_RESULTS_ERROR = 'SearchResultsError';
const ZERO_QUERY_RENDERED = 'ZeroQueryRendered';

export {
    LAUNCH_SEARCH,
    START_SEARCH,
    SEARCH_NO_RESULTS_RENDERED,
    SEARCH_RESULTS_RENDERED,
    SEARCH_RESULTS_ERROR,
    ZERO_QUERY_RENDERED,
};
